import { Route, Switch } from "react-router";
import PartsTable from "./PartsTable";

export default () => (
  <Switch>
    <Route exact path="/inventory/parts" component={PartsTable} />
  </Switch>
);
